import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Product } from "../types/product";

export interface ListProductsQueryFilters {
  page?: number;
  perPage?: number;
  search?: string;
  ids?: number[] | string;
}

export async function getProductsService(filters?: ListProductsQueryFilters): Promise<Product[]> {
  try {
    const { data } = await api.get<ApiResponse<Product>>(`v1/default_product_admin/`, {
      params: {
        page: filters?.page,
        page_size: filters?.perPage,
        search: filters?.search,
        ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : filters?.ids,
      },
    });
    return data.results;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
}

export async function getProductByIdService(id: number): Promise<Product> {
  try {
    const { data } = await api.get<Product>(`v1/default_product_admin/${id}/`);
    return data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
}

export async function createProductService(product: Omit<Product, 'id'>): Promise<Product> {
  try {
    const { data } = await api.post<Product>(`v1/default_product_admin/`, product);
    return data;
  } catch (error) {
    console.error("Error creating product:", error);
    throw error;
  }
}

export async function updateProductService(id: number, product: Partial<Product>): Promise<Product> {
  try {
    const { data } = await api.patch<Product>(`v1/default_product_admin/${id}/`, product);
    return data;
  } catch (error) {
    console.error("Error updating product:", error);
    throw error;
  }
}

export async function deleteProductService(id: number): Promise<void> {
  try {
    await api.delete(`v1/default_product_admin/${id}/`);
  } catch (error) {
    console.error("Error deleting product:", error);
    throw error;
  }
}
